import React, { useEffect, useState } from "react";
import { Box, Container, Grid } from "@mui/material";
import { toast } from "react-toastify";
import apis from "services";
import { DataGrid } from "@mui/x-data-grid";
import AdminWithDrawlTable from "components/datagrid/AdminWithDrawlTable";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Header } from "components";
import ApproveWithDrawlModal from "components/modals/ApproveWithDrawlModal";
import WithdrawlReceiptModal from "components/modals/WithdrawlReceiptModal";

import useNavigate from "hooks/Navigate";
const AdminWithDrawl = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState(false);
  const [receiptmodal, setReceiptModal] = useState(false);
  const [documentModal, setDocumentModal] = useState(false);

  const [item, setItem] = useState({});
  const [documentItem, setDocumentItem] = useState({});

  const [withDrawId, setWithDrawlId] = useState("");
  const [loading, setLoading] = useState(false);

  const [amount, setAmount] = useState(0);
  const [fullName, setFullName] = useState("");
  const paidAmount = Number(amount || 0) * 0.9;

  const handleShow = () => {
    setStatus(true);
  };
  const handleClose = () => {
    setStatus(false);
  };
  const [withDrawl, setWithDrawl] = useState([]);

  const fetchAllWithDrawlUser = async () => {
    setLoading(true);
    try {
      const res = await apis.getAllWithdrawl();
      setWithDrawl(res?.data?.withDrawl || []);
    } finally {
      setLoading(false);
    }
  };

  const handleApprovedWithDrawl = async (id, selectedAmount, selectedFullName) => {
    setWithDrawlId(id);
    setAmount(selectedAmount);
    setFullName(selectedFullName);
    handleShow();
  };

  const handleRejectWithDrawl = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to reject this withdrawl request?");

    if (!isConfirmed) return;

    try {
      const res = await apis.rejectWithdrawl(id);
      if (res?.data?.status) {
        toast.success(res?.data?.message || "Withdrawl request rejected successfully");
        await fetchAllWithDrawlUser();
      } else {
        toast.error(res?.data?.message || "Unable to reject withdrawl request");
      }
    } catch (error) {
      toast.error(error?.message || "Unable to reject withdrawl request");
    }
  };

  useEffect(() => {
    (async () => {
      await fetchAllWithDrawlUser();
    })();
  }, []);

  const toggleReceiptModal = (dataItem = {}) => {
    setItem(dataItem);
    setReceiptModal((prevState) => !prevState);
  };

  const openDocumentModal = (dataItem = {}) => {
    setDocumentItem({ ...dataItem, file: dataItem?.document });
    setDocumentModal(true);
  };

  const closeDocumentModal = () => {
    setDocumentModal(false);
    setDocumentItem({});
  };

  const methods = {
    navigate,
    handleApprovedWithDrawl,
    handleRejectWithDrawl,
    toggleReceiptModal,
    openDocumentModal,
  };

  const { rows, columns } = AdminWithDrawlTable(withDrawl, methods);

  return (
    <>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <Header />
            {loading ? (
              <div className="loader-container">
                <div className="loader" />
              </div>
            ) : (
              <Container
                maxWidth="lg"
                sx={{ mt: 4, mb: 4 }}
                className="mainContainerComp"
              >
                <Grid
                  item
                  container
                  justifyContent="flex-end"
                  className="mt-4"
                  sx={{ height: "600px", position: "relative", zIndex: "10" }}
                >
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
                    }
                    pageSizeOptions={[10, 25, 50]}
                  />
                  <img
                    src="/assets/images/frameCardBG.png"
                    alt="frameCardBG"
                    style={{
                      position: "absolute",
                      bottom: "-46px",
                      left: "-24px",
                      width: "296px",
                      zIndex: "-1",
                    }}
                    className="card-bg-img"
                  />
                </Grid>
              </Container>
            )}
          </Box>
        </div>
      </Box>

      <ApproveWithDrawlModal
        status={status}
        close={handleClose}
        amount={amount}
        fullName={fullName}
        paidAmount={paidAmount}
        withDrawId={withDrawId}
        fetchAllWithDrawlUser={fetchAllWithDrawlUser}
      />
      <WithdrawlReceiptModal
        toggleModal={toggleReceiptModal}
        status={receiptmodal}
        data={item}
        title="Withdrawl Receipt"
      />
      <WithdrawlReceiptModal
        toggleModal={closeDocumentModal}
        status={documentModal}
        data={documentItem}
        title="Attached Withdrawl Document"
      />
    </>
  );
};

export default AdminWithDrawl;
